import React from "react";
import {Flex, Space} from "antd";
import {AddressBook} from "@phosphor-icons/react";
import {useViewerStore} from "../../../../../../store/store";

const AddressInfoSection : React.FC = () => {

    const { siteAddress } =  useViewerStore();


    return(
        <Space
            direction='vertical'
            style={{width: '100%'}}
        >
            <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}>
                <AddressBook size={32}/>Address
            </Flex>
            <br/>
            <span
                className='user__label'>{siteAddress ?? "No address found"}</span>
        </Space>
    )
}

export default AddressInfoSection;